import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guarda que bloqueia acesso de usuários do tipo "Individual" a rotas específicas.
 * Usuários individuais são redirecionados para o dashboard caso tentem acessar rotas restritas.
 */
export const individualRestrictionGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const userRole = authService.getUserRole();

  if (userRole === 'Individual') {
    // Redireciona usuários individuais para o dashboard
    router.navigate(['/dash']);
    return false;
  }

  return true;
};